/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_AttributesInputs */

const en_marketplace_attributes = /** @type {(inputs: Marketplace_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace Attributes`)
};

const es_marketplace_attributes = /** @type {(inputs: Marketplace_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atributos del mercado`)
};

const fr_marketplace_attributes = /** @type {(inputs: Marketplace_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attributs de la marketplace`)
};

const de_marketplace_attributes = /** @type {(inputs: Marketplace_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktplatz-Attribute`)
};

const ja_marketplace_attributes = /** @type {(inputs: Marketplace_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーケットプレイス属性`)
};

const zh_marketplace_attributes = /** @type {(inputs: Marketplace_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`市场属性`)
};

const ar_marketplace_attributes = /** @type {(inputs: Marketplace_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سمات السوق`)
};

const id_marketplace_attributes = /** @type {(inputs: Marketplace_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atribut Marketplace`)
};

const it_marketplace_attributes = /** @type {(inputs: Marketplace_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attributi del Marketplace`)
};

const ru_marketplace_attributes = /** @type {(inputs: Marketplace_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Атрибуты маркетплейса`)
};

const pt_marketplace_attributes = /** @type {(inputs: Marketplace_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atributos do Marketplace`)
};

const ko_marketplace_attributes = /** @type {(inputs: Marketplace_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마켓플레이스 속성`)
};

/**
* | output |
* | --- |
* | "Marketplace Attributes" |
*
* @param {Marketplace_AttributesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const marketplace_attributes = /** @type {((inputs?: Marketplace_AttributesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_AttributesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketplace_attributes(inputs)
	if (locale === "es") return es_marketplace_attributes(inputs)
	if (locale === "fr") return fr_marketplace_attributes(inputs)
	if (locale === "de") return de_marketplace_attributes(inputs)
	if (locale === "ja") return ja_marketplace_attributes(inputs)
	if (locale === "zh") return zh_marketplace_attributes(inputs)
	if (locale === "ar") return ar_marketplace_attributes(inputs)
	if (locale === "id") return id_marketplace_attributes(inputs)
	if (locale === "it") return it_marketplace_attributes(inputs)
	if (locale === "ru") return ru_marketplace_attributes(inputs)
	if (locale === "pt") return pt_marketplace_attributes(inputs)
	return ko_marketplace_attributes(inputs)
});